/**
 * @preserve
 * Copyright 2015-2016 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * iq.ts - Image Quantization Library
 */
import * as arithmetic from "./arithmetic"
import { HueStatistics } from "./hueStatistics"
import { Palette } from "./palette"
import { Point } from "./point"
import { PointContainer } from "./pointContainer"

export {
    Point,
    PointContainer,
    Palette,
    HueStatistics,
    arithmetic
}



/** WEBPACK FOOTER **
 ** ./src/utils/index.ts
 **/